import React from "react";
import { textContent, titleContent } from "../../Styles";
import { FaDownload } from "react-icons/fa";
import androidImg from "../../assets/android.png";
import iosImg from "../../assets/ios.png";
import macImg from "../../assets/mac.png";
import windowsImg from "../../assets/windows.png";
import { Android } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
function Downloads() {
  const navigate = useNavigate();
  return (
    <div className="bg_download_img relative w-full h-fit">
      <div className="text-white flex flex-col  gap-5 h-fit w-full  items-center justify-center mobile:p-5 p-8">
        <div className="relative right-[-120px] largeScreen:top-40 w-full largeScreen:mt-5 flex flex-col gap-1 h-full justify-center items-center">
          <div className="absolute right-10 mobile:border-[18px] ipadMin:border-[18px]  border-[24px] border-lime-800/40 border-[#38761D70]  rounded-full  w-[200px] h-[200px]"></div>
          <div className="absolute ipadMin:hidden mobile:hidden  mt-[350px] right-24  border-[10px] border-[#38761D70]   rounded-full w-[120px] h-[120px]"></div>
          {/* <div className="absolute mt-60 right-10 border-2 border-[#FBE204] border-opacity-[20%]  rounded-full w-[200px] h-[200px]"></div> */}
        </div>
        <div className="relative left-[-120px] mobile:left-0 largeScreen:top-40 w-full largeScreen:mt-5 flex flex-col gap-1 h-full justify-center items-center">
          <div className="absolute top-0 mt-[-40px] mobile:mt-[-10px] ipadMax:mt-0 ipadMin:left-24 mobile:left-[-20px] left-24 border-[10px] border-[#38761D70] rounded-full w-[120px] h-[120px] mobile:w-[80px] mobile:h-[80px]"></div>
        </div>
      </div>
      <div className="w-full relative z-10 mt-[-50px] mobile:mt-0 flex flex-row mobile:flex-col ipadMin:flex-col  mobile:gap-2 gap-10 items-center justify-center ipadMin:p-4 mobile:p-4 p-10">
        <div className="items-center justify-center text-white flex flex-row mobile:w-full ipadMin:w-full  gap-5 h-full w-[40%] ">
          <img
            className="w-[550px]  mobile:w-full object-contain h-full"
            src={require("../../assets/downloadhome.png")}
            alt=""
            srcSet=""
          />
        </div>
        <div className="items-start justify-start ipadMin:items-center ipadMin:justify-center mobile:items-center mobile:justify-center text-white flex flex-col  gap-5 h-full mobile:w-full ipadMin:w-full   w-[60%] ">
          <h1 className=" justify-start text-neutral-800 mobile:text-[14px] ipadMin:text-lg text-4xl font-bold">
            Available on all your devices
          </h1>
          <p className="self-stretch justify-start ipadMin:justify-center mobile:justify-center mobile:text-[10px] text-neutral-700 text-xs font-normal ">
            Fully optimized for macOS, Windows, iOS, and Android to give you the
            best experience on any screen.
          </p>

          <button
            onClick={() => navigate("/download")}
            className="mt-5 mobile:mt-2 hover:bg-gradient-to-b from-lime-800 to-lime-500 flex mobile:text-[10px] text-lg mobile:text-[14px] items-center gap-2 px-8 py-3 bg-lime-800 text-white  shadow-md hover:bg-lime-900 transition"
          >
            <FaDownload />
            Free Download
          </button>
          <div className="flex flex-row gap-3  pl-5 ">
            <img
              src={androidImg}
              alt={Android}
              className="w-8 h-8 mobile:h-6 object-contain"
            />
            <img
              src={iosImg}
              alt={iosImg}
              className="w-8 h-8 mobile:h-6 object-contain"
            />
            <img
              src={macImg}
              alt={macImg}
              className="w-8 h-8 mobile:h-6 object-contain"
            />
            <img
              src={windowsImg}
              alt={windowsImg}
              className="w-8 h-8 mobile:h-6 object-contain"
            />
          </div>
          <div className="w-full mobile:justify-center  justify-end flex mobile:mt-0 mt-[-50px]">
            <img
              className="w-[140px] mobile:w-full  object-contain  mobile:h-[80px] h-[100px]"
              src={require("../../assets/plant.png")}
              alt=""
              srcSet=""
            />
          </div>
        </div>
      </div>
      <div className="relative w-full  largeScreen:mt-5 flex">
        {/* Circle */}
        <div className="absolute z-0 bottom-0 left-[-50px]  mb-[-100px] mobile:border-[18px] ipadMin:border-[18px]  border-[24px] border-lime-800/40 border-[#38761D70]  rounded-full  w-[200px] h-[200px]"></div>
      </div>
    </div>
  );
}

export default Downloads;
